import * as React from "react";

const WarningStock: React.FC = () => {
    return <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Cart-Line/Partially-In-Stock" transform="translate(-415.000000, -79.000000)" fill="currentColor">
            <g id="Inventory" transform="translate(415.000000, 78.000000)">
                <path d="M8,1 C3.58165625,1 0,4.58178125 0,9 C0,13.4184687 3.58165625,17 8,17 C12.4183438,17 16,13.4184688 16,9 C16,4.58178125 12.4183438,1 8,1 Z M8,13.5 C7.4476875,13.5 7,13.0525 7,12.5 C7,11.94775 7.4476875,11.5 8,11.5 C8.5523125,11.5 9,11.94775 9,12.5 C9,13.0525 8.5523125,13.5 8,13.5 Z M9,10.5 L7,10.5 L6.5,4.72222222 C6.5,4.323375 6.723875,4 7,4 L9,4 C9.276125,4 9.5,4.323375 9.5,4.72222222 L9,10.5 Z" id="Shape"></path>
            </g>
        </g>
    </g>
</svg>
;
};

export default React.memo(WarningStock);
